// extracted by mini-css-extract-plugin
export default {"baseButton":"BaseButton_baseButton__Fm962","iconLeft":"BaseButton_iconLeft__cuPKA","isDisabled":"BaseButton_isDisabled__X3O6E"};